import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import LoginRegisterTabs from '../LoginRegisterTabs';
import { useCookies } from 'react-cookie';

import {
  makeStyles,
} from "@material-ui/core";


const useStylesAll = makeStyles(theme => ({
  pageContainer: {
    position: "absolute",
    width: "100%",
    fontFamily: "Poppins",
  },
  container: {
    width: "85%",
    backgroundColor: '#FFFFFF',
    margin: "30px auto",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up('md')]: {
      margin: "20vh auto",
      width: 625,
      padding: "30px",
    },
    '@media (max-height:750px)': {
      marginTop: '180px',
    }
  },
  btn: {
    marginTop: "30px",
    [theme.breakpoints.up('md')]: {
      marginTop: "40px",
    },
  },

}));


function RegisterFinishPage(props) {
  const { t, i18n } = useTranslation('register');
  const { isRenew, isResumePay, lang, toLogout, logoutTrue } = props;
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const history = useHistory();
  const location = useLocation();
  const [action, setAction] = React.useState('thx.');
  const [cookies, setCookie] = useCookies();

  useEffect(() => {
    if (isRenew) {
      setAction('renew.thx.');
    }
    const path = location.pathname.split('/');
    if (path[2] == 'fail') {
      setAction('fail.');
    }
    if(isResumePay){
      logoutTrue();
    }
  }, [location.pathname])

  useEffect(() => {
    if (!location.pathname.match(/\/(tc|en)\//g)) {
      const path = location.pathname.split('/');
      window.location.replace(path[0] + cookies.lang + "/" + path[1]);
    }
    
  }, [cookies.lang])

  function toLogin() {
    history.push("/login");
  }

  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.container}>

        <Grid container spacing={1}>
          <Grid item xs={12}>
            {!isRenew ?
              <LoginRegisterTabs active="register" />
              : <></>}
            <Typography variant="h1">{t(action + 'title')}</Typography>
            <Typography variant="h2" style={{ marginBottom: 0, color: "#333333" }}>{t(action + 'content')}</Typography>
          </Grid>
        </Grid>

        <Button type="button" className={classes.btn} variant="contained" fullWidth onClick={toLogin}>{t(action + 'btn')}</Button>
      </Box>
    </Box>
  );
}

export default RegisterFinishPage;
